<template>
  <section>
    <div
      class="relative mx-auto mt-12 mb-8 grid grid-cols-1 gap-4 md:gap-10 lg:max-w-none lg:grid-cols-6"
    >
      <div class="col-span-1 lg:col-span-4">
        <div class="max-w-prose">
          <h3 class="text-base font-bold text-yellow-400 uppercase">
            Activities
          </h3>
          <h2 class="mt-0.5 mb-8 text-3xl font-extrabold text-white">
            Get {{ blok.activities?.length ?? 0 }} Premier Activities For Just
            £{{ formatPrice(Number(blok.products?.[0]?.price ?? 0)) }}
            <br />
            <span class="text-xl font-medium text-neutral-400"
              >(Usually £{{ formatPrice(Number(blok.original_price ?? 0)) }}/{{
                blok.products?.[0]?.price_per_type ?? ''
              }})</span
            >
          </h2>
        </div>
        <div
          class="grid grid-cols-1 gap-4 md:gap-6 lg:max-w-none lg:grid-cols-3"
        >
          <div
            v-for="(activity, i) in blok.activities ?? []"
            :key="i"
            class="col-span-1"
          >
            <LazyMarketingCardActivity :activity="activity" type="package" />
          </div>
        </div>
      </div>
      <div class="col-span-1 lg:col-span-2">
        <h3 class="text-base font-bold text-yellow-400 uppercase">Location</h3>
        <h2 class="mt-0.5 mb-8 text-3xl font-extrabold text-white">
          Only At {{ blok.locations?.[0]?.name ?? '' }}
        </h2>
        <div
          v-for="(location, i) in blok.locations ?? []"
          :key="i"
          class="col-span-1"
        >
          <LazyMarketingCardContactInfo :blok="location.content" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { PackageStoryblok } from '~/types/component-types-sb';

const { formatPrice } = useFormatPrice();

interface Props {
  blok: PackageStoryblok;
  type: string;
}

defineProps<Props>();
</script>
